import { lazy } from 'solid-js'
import { messages } from '../../pages/ontario-vacation-rentals-page/ontario-vacation-rentals-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/ontario-vacation-rentals-page/ontario-vacation-rentals-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/ontario/vacation-rentals',
    titleMessage: messages.titleMessage,
}
